<template>
    <div v-for="(order, orderIndex) in orders" :key="order.orderId" class="order-single">
        <div v-if="order.lineItems?.length" class="order-content">
            <order-history-card
                v-for="(lineItem, lineItemIndex) in order.lineItems"
                :key="`${order.orderId}-${lineItem.productId}`"
                :order-line-item="lineItem"
                :order-id="order.orderId"
                :created-at="order.createdAt"
                :language="language"
                :is-last="isLastItem(orderIndex, lineItemIndex, order)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { IOrderHistoryCardList, OrderHistoryDto } from '../../types';
import OrderHistoryCard from '../card/OrderHistoryCard.vue';
import { isLastItemReached } from '@/helpers';

const props = defineProps<IOrderHistoryCardList>();

const isLastItem = (orderIndex: number, lineItemIndex: number, order: OrderHistoryDto) =>
    isLastItemReached(orderIndex, props.orders.length) && isLastItemReached(lineItemIndex, order.lineItems.length);
</script>
